export const baseUrl = "/api";
